import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { Button, ButtonWithSpinner, Card, CardTitle, Divider, ToastContext } from '@reveni-io/reveni-ui'

import routes from '@/Router/routes.constants'

import useComplete from '../hooks/useComplete/useComplete'
import BreakDown from './BreakDown/BreakDown'
import CustomerDetails from './CustomerDetails/CustomerDetails'
import CustomerNotification from './CustomerNotification/CustomerNotification'
import ProductSelection from './ProductSelection/ProductSelection'
import RefundMethod from './RefundMethod/RefundMethod'
import ReturnDetails from './ReturnDetails/ReturnDetails'
import * as Styles from './styles'

const SummaryCard = ({ loadingBreakdown, loadingDeliveryMethodDetails, onChangeRefundMethod }) => {
  const { t } = useTranslation()
  const { setToastInfo } = useContext(ToastContext)
  const { handleCompleteRma, completingRma, isCompleteRmaValid } = useComplete({ setToastInfo })
  const navigation = useNavigate()

  const handleCancel = () => {
    navigation(routes.transactionsPage)
  }

  return (
    <Card showBorder={false}>
      <CardTitle>{t('Resumen')}</CardTitle>
      <Styles.Container>
        <ProductSelection />
        <Divider />
        <ReturnDetails loading={loadingDeliveryMethodDetails} />
        <Divider />
        <CustomerDetails />
        <Divider />
        <BreakDown loadingBreakdown={loadingBreakdown} />
        <RefundMethod onChangeRefundMethod={onChangeRefundMethod} />
        <Divider />
        <CustomerNotification />
        <Styles.ButtonsContainer>
          <ButtonWithSpinner
            defaultLabel={t('Crear solicitud')}
            loadingLabel={t('Creando solicitud')}
            loading={completingRma}
            onClick={handleCompleteRma}
            disabled={!isCompleteRmaValid()}
          />
          <Button variant="outlined" onClick={handleCancel}>
            {t('Cancelar')}
          </Button>
        </Styles.ButtonsContainer>
      </Styles.Container>
    </Card>
  )
}

export default SummaryCard
